// import packages
import React from "react"
import { withBreadcrumb, useBread } from "components/breadcrumb"
import { userInfo } from "utils"

// import components
import ProductDetail from "./backOffice/ProductDetail"
import ProductDetailPageCl from "./clientOffice/ProductDetailPageCl"

// main component
const ProductDetailContainer = props => {
  const { role: userRole } = userInfo()

  useBread({
    to: props.match.url,
    name: props.match.params.id ? "維護產品" : "新增產品"
  })

  if (!userRole) {
    return <div>404</div>
  }

  if (userRole === "CUSTOMER") {
    return <ProductDetailPageCl />
  }

  if (props.match.params.id) {
    return <ProductDetail id={props.match.params.id} />
  }

  return <ProductDetail />
}

// export component
export default withBreadcrumb(ProductDetailContainer)
